var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0.997559C5.43009 0.997534 4.64048 1.30741 4.03942 1.86506C3.43837 2.42272 3.0703 3.18695 3.009 4.00456C3.089 3.99956 3.169 3.99756 3.25 3.99756H12.75C13.8772 3.99756 14.9582 4.44533 15.7552 5.24235C16.5522 6.03938 17 7.12039 17 8.24756V14.7476C17 14.8276 16.998 14.9086 16.993 14.9886C17.8106 14.9273 18.5748 14.5592 19.1325 13.9581C19.6902 13.3571 20 12.5675 20 11.7476V5.74756C20 5.12378 19.8771 4.50611 19.6384 3.92981C19.3997 3.35352 19.0498 2.82988 18.6088 2.3888C18.1677 1.94772 17.644 1.59784 17.0677 1.35913C16.4915 1.12042 15.8738 0.997559 15.25 0.997559H6.25ZM15.99 14.9976C15.927 15.8137 15.5584 16.5761 14.9577 17.1323C14.357 17.6885 13.5686 17.9975 12.75 17.9976H8.667L5 20.7476C4.176 21.3656 3 20.7776 3 19.7476V17.9876C2.18381 17.9246 1.42145 17.5559 0.865278 16.9553C0.309105 16.3546 9.32843e-05 15.5662 0 14.7476V8.24756C0 7.3856 0.34241 6.55895 0.951903 5.94946C1.5614 5.33997 2.38805 4.99756 3.25 4.99756H12.75C13.612 4.99756 14.4386 5.33997 15.0481 5.94946C15.6576 6.55895 16 7.3856 16 8.24756V14.7476C16 14.8316 15.997 14.9156 15.99 14.9976Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comment.ada5c4e74613ee4f54e16e3517027466.svg";